import { useCallback } from 'react';

import { Button } from '../../../Button';
import { NavItemData } from '../../../services/content';

import styles from './MegaNavSectionLink.module.css';

export interface MegaNavSectionLinkProps {
  link: NavItemData;
  onPress: (link: NavItemData) => void;
}

export const MegaNavSectionLink = ({ link, onPress }: MegaNavSectionLinkProps) => {
  const handlePress = useCallback(() => {
    onPress(link);
  }, [link, onPress]);

  return (
    <Button
      emphasis="quaternary"
      fullWidth
      href={link.url}
      iconStartProps={link.leftIcon ? { iconName: link.leftIcon } : undefined}
      key={link.label}
      onPress={handlePress}
      passthroughProps={{ title: link.label }}
      size="sm"
      styleVariant="neutral"
    >
      <span className={styles.linkText}>{link.label}</span>
    </Button>
  );
};
